import { useEffect } from "react";

import { AlluLogo } from "@/components/parceiros/AlluLogo";
import { ParceiroCadastroForm } from "@/components/parceiro-cadastro/ParceiroCadastroForm";
import { WhatsappHelp } from "@/components/parceiro-cadastro/WhatsappHelp";

const PAGE_TITLE = "Cadastro de Parceiro — Allu";

const ParceiroCadastro = () => {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = PAGE_TITLE;

    // Não indexar — página acessível só por link
    const robotsMeta = document.querySelector('meta[name="robots"]');
    const prevRobots = robotsMeta?.getAttribute("content") ?? "";
    robotsMeta?.setAttribute("content", "noindex, nofollow");

    const prevBodyBg = document.body.style.backgroundColor;
    const prevBodyColor = document.body.style.color;
    const prevBodyFont = document.body.style.fontFamily;
    document.body.style.backgroundColor = "#FAF8F5";
    document.body.style.color = "#112711";
    document.body.style.fontFamily =
      '"Plus Jakarta Sans", Inter, system-ui, -apple-system, sans-serif';

    return () => {
      document.title = prevTitle;
      robotsMeta?.setAttribute("content", prevRobots);
      document.body.style.backgroundColor = prevBodyBg;
      document.body.style.color = prevBodyColor;
      document.body.style.fontFamily = prevBodyFont;
    };
  }, []);

  return (
    <div
      className="min-h-screen bg-[#FAF8F5] text-[#112711] flex flex-col"
      style={{
        fontFamily:
          '"Plus Jakarta Sans", Inter, system-ui, -apple-system, sans-serif',
      }}
    >
      {/* Header sóbrio */}
      <header className="border-b border-zinc-200/70">
        <div className="max-w-2xl mx-auto px-4 sm:px-6 py-5 flex items-center justify-between">
          <AlluLogo variant="dark" className="h-8 sm:h-9 w-auto" />
          <span className="text-[11px] font-semibold tracking-[0.14em] uppercase text-zinc-400">
            Formalização de Parceria
          </span>
        </div>
      </header>

      <main className="flex-1">
        <div className="max-w-2xl mx-auto px-4 sm:px-6 py-10 sm:py-16 w-full">
          <div className="rounded-3xl bg-white border border-zinc-200/80 shadow-sm p-6 sm:p-10">
            <ParceiroCadastroForm />
          </div>

          <p className="mt-6 text-center text-xs text-zinc-400 leading-relaxed">
            Seus dados são usados exclusivamente para a formalização da parceria
            com a Allu Invest.
          </p>
        </div>
      </main>

      <WhatsappHelp />
    </div>
  );
};

export default ParceiroCadastro;
